/*!
 * Alpha Posts - Version: 2.4.2
 * Indeed - Copyright (c) 2026
 * This file is generated automatically. Do not edit.
 *
 * Contains sources adapted from Twitter Bootstrap v4.0.0-alpha.3, which are
 * licensed under MIT (https:
 */

const SEARCH_DEBOUNCE_MS = 250;
const ALPHA_FILTER_DEBOUNCE_MS = 150;
const THIRD_PARTY_EVENTS = ['mousedown', 'mouseup', 'pointerdown', 'pointerup', 'pointerover', 'mouseover', 'pointerenter', 'mouseenter'];
const pageSizeResizeHandlers = [];

function blockThirdPartyEvents(el) {
  THIRD_PARTY_EVENTS.forEach((evt) => {
    el.addEventListener(evt, (e) => e.stopPropagation(), true);
  });
}

function getPageSizeForViewport() {
  if (window.innerWidth < 579) {
    return 12;
  }
  if (window.innerWidth < 768) {
    return 20;
  }
  if (window.innerWidth < 992) {
    return 18;
  }
  return 40;
}
function initAlphaPosts(rootEl) {
  let listItemEntries = [];
  let pageSize;
  let currentPage = 1;
  let searchQuery = '';
  let alphaFilter = null;
  let lastTotalPages = -1;

  let paginationWrapper;
  let pageButtonsList;
  let nextButton;
  let prevButton;
  let alphaPostsSearch;
  let listLoadingOverlay;
  let listLoadingText;
  let alphaPostsNoResults;
  let alphaPostsListWrapper;

  let searchDebounceTimer = null;
  let alphaFilterDebounceTimer = null;
  let isNavigating = false;

  function showListSpinner() {
    if (!listLoadingOverlay) {
      return;
    }
    if (alphaPostsListWrapper) {
      listLoadingOverlay.style.height = alphaPostsListWrapper.offsetHeight + 'px';
    }
    listLoadingOverlay.classList.add('is-visible');
    if (listLoadingText) {
      listLoadingText.textContent = 'Loading';
    }
  }

  function hideListSpinner() {
    if (!listLoadingOverlay) {
      return;
    }
    listLoadingOverlay.classList.remove('is-visible');
    listLoadingOverlay.style.height = '';
    if (listLoadingText) {
      listLoadingText.textContent = '';
    }
  }

  function runWithListSpinner(fn) {
    setTimeout(() => {
      showListSpinner();
      setTimeout(() => {
        try {
          fn();
        } finally {
          hideListSpinner();
        }
      }, 0);
    }, 0);
  }

  function getMatchingItems() {
    const q = searchQuery.trim().toLowerCase();
    return listItemEntries.filter((entry) => {
      if (alphaFilter && !alphaFilter.includes(entry.firstLetter)) {
        return false;
      }
      if (q && !entry.titleLower.includes(q)) {
        return false;
      }
      return true;
    });
  }

  function computeTotalPages(matchingCount) {
    if (matchingCount <= 0) {
      return 1;
    }
    return Math.ceil(matchingCount / pageSize);
  }

  function updateNoResults(empty) {
    if (alphaPostsNoResults) {
      alphaPostsNoResults.style.display = empty ? 'block' : 'none';
    }
    if (alphaPostsListWrapper) {
      alphaPostsListWrapper.style.display = empty ? 'none' : 'block';
    }
  }

  function syncListVisibility(matching) {
    listItemEntries.forEach((entry) => {
      entry.el.style.display = 'none';
      entry.el.setAttribute('aria-hidden', 'true');
    });
    matching.forEach((entry, idx) => {
      const itemPage = Math.floor(idx / pageSize) + 1;
      if (itemPage === currentPage) {
        entry.el.style.display = '';
        entry.el.setAttribute('aria-hidden', 'false');
      }
    });
  }

  function renderPaginationButtons(totalPages) {
    if (!pageButtonsList) {
      return;
    }
    pageButtonsList.innerHTML = '';
    for (let p = 1; p <= totalPages; p++) {
      const li = document.createElement('li');
      if (p === currentPage) {
        li.classList.add('active');
      }
      if (totalPages === 1 && p === 1) {
        li.classList.add('single-page');
      }
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'page';
      btn.textContent = String(p);
      btn.dataset.page = String(p);
      li.appendChild(btn);
      pageButtonsList.appendChild(li);
    }
  }

  function updateActivePageButton() {
    if (!pageButtonsList) {
      return;
    }
    pageButtonsList.querySelectorAll('li').forEach((li) => li.classList.remove('active'));
    const btn = pageButtonsList.querySelector(`button.page[data-page="${currentPage}"]`);
    if (btn) {
      btn.closest('li').classList.add('active');
    }
  }

  function truncatePaginationWindow() {
    if (!pageButtonsList || !paginationWrapper) {
      return;
    }
    const WINDOW_OFFSET = 1;
    pageButtonsList.querySelectorAll('li.disabled').forEach((el) => el.remove());

    const currentPageNumber = currentPage;
    const left = currentPageNumber - WINDOW_OFFSET;
    const right = currentPageNumber + WINDOW_OFFSET + 1;
    const last = pageButtonsList.childElementCount;
    if (last === 0) {
      return;
    }

    const pageButtonsToShow = [];
    for (let pageNumber = 1; pageNumber <= last; pageNumber++) {
      if (pageNumber === 1 || pageNumber === last || (pageNumber >= left && pageNumber < right)) {
        pageButtonsToShow.push(pageNumber);
        pageButtonsList.children[pageNumber - 1].style.display = '';
      } else {
        pageButtonsList.children[pageNumber - 1].style.display = 'none';
      }
    }

    const ellipsisLi = document.createElement('li');
    ellipsisLi.classList.add('disabled');
    ellipsisLi.setAttribute('aria-hidden', 'true');
    const ellipsisBtn = document.createElement('button');
    ellipsisBtn.type = 'button';
    ellipsisBtn.className = 'page';
    ellipsisBtn.textContent = '…';
    ellipsisBtn.disabled = true;
    ellipsisLi.appendChild(ellipsisBtn);

    let ellipsisInsertCount = 0;
    let previousPageNumber = 0;
    for (const pageNumber of pageButtonsToShow) {
      if (previousPageNumber > 0 && pageNumber - previousPageNumber > 1) {
        const refIndex = pageNumber - 1 + ellipsisInsertCount;
        const refNode = pageButtonsList.children[refIndex];
        if (refNode) {
          pageButtonsList.insertBefore(ellipsisLi.cloneNode(true), refNode);
          ellipsisInsertCount += 1;
        }
      }
      previousPageNumber = pageNumber;
    }
  }

  function updateArrowButtons(totalPages, matchCount) {
    if (!prevButton || !nextButton) {
      return;
    }
    if (matchCount === 0) {
      prevButton.disabled = true;
      nextButton.disabled = true;
      return;
    }
    prevButton.disabled = currentPage <= 1;
    nextButton.disabled = currentPage >= totalPages;
  }
  function applyView(options = {}) {
    if (!listItemEntries.length) {
      return;
    }
    const matching = getMatchingItems();
    const totalPages = computeTotalPages(matching.length);

    if (currentPage > totalPages) {
      currentPage = totalPages;
    }

    updateNoResults(matching.length === 0);
    syncListVisibility(matching);

    if (paginationWrapper) {
      paginationWrapper.dataset.page = String(currentPage);
      paginationWrapper.dataset.pages = String(totalPages);
    }

    const needFullPagination = options.forcePaginationRebuild || totalPages !== lastTotalPages;
    lastTotalPages = totalPages;

    if (needFullPagination) {
      renderPaginationButtons(totalPages);
    }

    truncatePaginationWindow();
    updateActivePageButton();
    updateArrowButtons(totalPages, matching.length);
  }

  function setupPaginationNumberClick() {
    if (!paginationWrapper || !pageButtonsList) {
      return;
    }
    paginationWrapper.addEventListener('click', (e) => {
      const pageEl = e.target.closest('button.page');
      if (!pageEl || pageEl.disabled) {
        return;
      }
      e.stopImmediatePropagation();
      e.stopPropagation();
      const label = pageEl.textContent.trim();
      if (label === '…' || label === '...') {
        return;
      }
      const page = parseInt(pageEl.dataset.page || label, 10);
      if (Number.isNaN(page)) {
        return;
      }
      if (isNavigating) {
        return;
      }
      isNavigating = true;
      runWithListSpinner(() => {
        try {
          currentPage = page;
          applyView();
        } finally {
          isNavigating = false;
        }
      });
    }, true);
  }

  function showNextPage() {
    nextButton.addEventListener('click', () => {
      if (isNavigating) {
        return;
      }
      const totalPages = lastTotalPages > 0
        ? lastTotalPages
        : computeTotalPages(getMatchingItems().length);
      if (currentPage >= totalPages) {
        return;
      }
      isNavigating = true;
      runWithListSpinner(() => {
        try {
          currentPage += 1;
          applyView();
        } finally {
          isNavigating = false;
        }
      });
    });
  }

  function showPreviousPage() {
    prevButton.addEventListener('click', () => {
      if (isNavigating) {
        return;
      }
      if (currentPage <= 1) {
        return;
      }
      isNavigating = true;
      runWithListSpinner(() => {
        try {
          currentPage -= 1;
          applyView();
        } finally {
          isNavigating = false;
        }
      });
    });
  }

  function setupAlphaFilterButtons() {
    const buttons = rootEl.querySelectorAll('.alphaposts-filter-button');
    if (!buttons.length) {
      return;
    }
    const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
    const existingFirstLetters = new Set(listItemEntries.map((entry) => entry.firstLetter));
    const missingLetters = alphabet.filter((letter) => !existingFirstLetters.has(letter));

    buttons.forEach((button) => {
      const raw = button.dataset.filter;
      const filters = raw ? raw.split(',') : null;

      if (filters && filters.length === 1 && missingLetters.includes(filters[0])) {
        button.disabled = true;
      }

      blockThirdPartyEvents(button);

      button.addEventListener('click', (e) => {
        e.stopImmediatePropagation();
        e.stopPropagation();

        const activeButton = rootEl.querySelector('.alphaposts-filter-button.active');
        if (activeButton) {
          activeButton.classList.remove('active');
        }
        e.currentTarget.classList.add('active');

        clearTimeout(alphaFilterDebounceTimer);
        alphaFilterDebounceTimer = setTimeout(() => {
          alphaFilterDebounceTimer = null;
          runWithListSpinner(() => {
            if (alphaPostsSearch && searchQuery.trim() !== '') {
              clearTimeout(searchDebounceTimer);
              searchDebounceTimer = null;
              alphaPostsSearch.value = '';
              searchQuery = '';
            }

            if (filters) {
              alphaFilter = filters.map((x) => x.trim().toUpperCase());
            } else {
              alphaFilter = null;
            }
            currentPage = 1;
            lastTotalPages = -1;
            applyView({ forcePaginationRebuild: true });
          });
        }, ALPHA_FILTER_DEBOUNCE_MS);
      });
    });
  }

  function scheduleDebouncedSearch(rawValue) {
    clearTimeout(searchDebounceTimer);
    searchDebounceTimer = setTimeout(() => {
      searchDebounceTimer = null;
      searchQuery = rawValue.trim();
      runWithListSpinner(() => {
        currentPage = 1;
        lastTotalPages = -1;
        applyView({ forcePaginationRebuild: true });
      });
    }, SEARCH_DEBOUNCE_MS);
  }

  function updateAlphapostsPageSize() {
    if (!listItemEntries.length) {
      return;
    }
    const next = getPageSizeForViewport();
    if (next === pageSize) {
      return;
    }
    pageSize = next;
    runWithListSpinner(() => {
      const matchingCount = getMatchingItems().length;
      const totalPages = computeTotalPages(matchingCount);
      currentPage = Math.min(currentPage, totalPages);
      lastTotalPages = -1;
      applyView({ forcePaginationRebuild: true });
    });
  }

  pageSize = getPageSizeForViewport();

  const listRoot = rootEl.querySelector('.alphaposts-list');
  if (!listRoot) {
    return;
  }

  listItemEntries = Array.from(listRoot.querySelectorAll('li')).map((el) => {
    const link = el.querySelector('a.name');
    const title = (link && link.textContent) ? link.textContent.trim() : '';
    const fromData = el.dataset.firstLetter;
    const firstLetter = (fromData || title.charAt(0) || '').toUpperCase();
    return {
      el,
      firstLetter,
      titleLower: title.toLowerCase(),
    };
  });

  alphaPostsSearch = rootEl.querySelector('.alphaposts-search');
  listLoadingOverlay = rootEl.querySelector('.alphaposts-list-loading');
  listLoadingText = listLoadingOverlay ? listLoadingOverlay.querySelector('.alphaposts-list-loading-text') : null;
  alphaPostsNoResults = rootEl.querySelector('.alphaposts-no-results');
  alphaPostsListWrapper = listRoot;

  pageSizeResizeHandlers.push(updateAlphapostsPageSize);

  setupAlphaFilterButtons();

  if (alphaPostsSearch) {
    blockThirdPartyEvents(alphaPostsSearch);
    alphaPostsSearch.addEventListener('input', (e) => {
      scheduleDebouncedSearch(e.target.value);
    });
  }

  setTimeout(() => {
    paginationWrapper = rootEl.querySelector('.alphaposts-pagination-wrapper');
    pageButtonsList = rootEl.querySelector('.alphaposts-pagination');
    nextButton = rootEl.querySelector('.alphaposts-pagination-arrow.next');
    prevButton = rootEl.querySelector('.alphaposts-pagination-arrow.previous');
    if (paginationWrapper) {
      blockThirdPartyEvents(paginationWrapper);
    }
    if (nextButton) {
      blockThirdPartyEvents(nextButton);
    }
    if (prevButton) {
      blockThirdPartyEvents(prevButton);
    }

    if (!paginationWrapper || !nextButton || !prevButton || !pageButtonsList) {
      applyView({ forcePaginationRebuild: true });
      return;
    }

    prevButton.disabled = true;
    setupPaginationNumberClick();
    showNextPage();
    showPreviousPage();
    applyView({ forcePaginationRebuild: true });
  }, 0);
}

function onResizeAllInstances() {
  pageSizeResizeHandlers.forEach((fn) => fn());
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.xds-alphaposts').forEach((root) => initAlphaPosts(root));
});
window.addEventListener('resize', onResizeAllInstances);

